import React from 'react';
import CentroEstivo2025 from '../components/CentroEstivo2025';

// Dati di default per la pagina standalone (non dipende dall'evento in API/Strapi)
const defaultEvent2025 = {
  Nome: 'Centro Estivo 2025',
  urlTitle: 'centro-estivo-2025',
  prezzo: 120,
  prezzoOriginale: null, // opzionale, per layout a 3 colonne
};

function CentroEstivo2025Page() {
  return <CentroEstivo2025 event={defaultEvent2025} />;
}

export default CentroEstivo2025Page;
